export default __webpack_public_path__ + "static/media/home-web-agency-img-01.f17e039a.jpg";